import { LocalDealer } from '../logic/dealer/local-dealer';
import { LocalRoundResultSubmitter } from '../../common/phaser/model/local-round-result-submitter';
import { LocalRoundParams, RoundParams } from '../../common/phaser/model/round-params';
import { BlocksListener } from '../game/blocks-listener';

export class BlocksLocalRoundParams extends LocalRoundParams {
  public readonly dealer: LocalDealer;

  constructor(dealer: LocalDealer, localRoundResultSubmitter: LocalRoundResultSubmitter) {
    super(localRoundResultSubmitter);
    this.dealer = dealer;
  }

  public static create(gameListener: BlocksListener): BlocksLocalRoundParams {
    return new BlocksLocalRoundParams(
      LocalDealer.makeRandom(),
      new LocalRoundResultSubmitter(gameListener),
    );
  }

  public static isRound(roundParams: RoundParams): roundParams is BlocksLocalRoundParams {
    return roundParams instanceof BlocksLocalRoundParams;
  }
}
